<div class="about-group">
  <div class="about-wrapper">
    <h1>Provider Terms and Conditions</h1>
    <h2>INTRODUCTION</h2>
    <p>
      Welcome to <a href="https://avaana.com.au">avaana.com.au</a>, an online marketplace connecting health,
      fitness, wellbeing, spa, beauty and other practitioners and businesses with Australians through an interactive
      online platform. The Platform is owned and operated by Avaana Pty Ltd ACN 610 520 600 (defined as Avaana, we, our
      and us).
    </p>
    <p>
      These Provider Terms and Conditions ( Terms) form a legally binding agreement between you (being, a Provider or
      Practitioner) and Avaana with effect from the Commencement Date. Capitalised words and expressions in these Terms
      have the meaning given to them in clause 12. In addition to these Terms, you agree to be bound by the Avaana Terms
      of Use and Booking Conditions and also the Community Guidelines.
    </p>
    <p>
      Please read these Terms carefully and if you have any questions in relation to these Terms, please obtain
      professional advice.
    </p>
    <p>
      If you do not accept these Terms, then you must not access the Platform or use the Avaana Services, other than as
      a Client or a Visitor.
    </p>
    <ol>
      <li>
        <h3>Account registration</h3>
        <ol>
          <li>
            <p>Registering for an Account</p>
            <ol>
              <li>
                <p>
                  To become a registered Provider, you must register for a Provider Account in relation to your access
                  to and use of the Platform and the Avaana Services, by completing the Signup Form and uploading to the
                  Platform all Provider Content required to create a Provider Account.
                </p>
              </li>
              <li>
                <p>
                  If you are a Provider, you may also register a Practitioner Account for each of your Practitioners by
                  uploading the email address of the Practitioner through the Signup Form or Business Dashboard.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Access to Accounts</p>
            <ol>
              <li>
                <p>
                  To access and use the Platform and the Avaana Services, you will be required to login to your Account
                  using:
                </p>
                <ol>
                  <li>
                    <p>
                      your email address as nominated in a Signup Form or as updated by you through the Business
                      Dashboard; and
                    </p>
                  </li>
                  <li>
                    <p>a password nominated by you through the Platform.</p>
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  You may change the password to your Account at any time by following instructions on the Platform.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Fair use</p>
            <p>By using the Platform, you agree that, in addition to exercising common sense:</p>
            <ol>
              <li>
                <p>you will not create more than one Account;</p>
              </li>
              <li>
                <p>
                  you will not create another Account if Avaana has already disabled your Account, unless you have
                  written permission from Avaana to do so;
                </p>
              </li>
              <li>
                <p>you will not share your password with any person; and</p>
              </li>
              <li>
                <p>
                  you will not log in or attempt to access the Platform through unauthorised third-party software or
                  clients.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Conditions of registration for Accounts</p>
            <p>
              You agree that it is a condition of creation of an Account and you continued use of the Platform and the
              Avaana Services that you:
            </p>
            <ol>
              <li>
                <p>
                  are at least 18 years of age and are otherwise capable of entering into a legally binding contract;
                </p>
              </li>
              <li>
                <p>hold a valid email address;</p>
              </li>
              <li>
                <p>have not been previously suspended or removed from the Platform by Avaana;</p>
              </li>
              <li>
                <p>
                  have all necessary and desirable qualifications and certifications required to perform the Provider
                  Services in accordance with Applicable Laws or which may otherwise be required or recommended by any
                  recognised professional or industry body that regulates the Provider Services which you provide;
                </p>
              </li>
              <li>
                <p>
                  have all due skill and expertise to provide your Provider Services to the highest industry standards;
                  and
                </p>
              </li>
              <li>
                <p>
                  have the legal capacity, power and authority to agree to be bound by these Terms and perform the
                  obligations contained in these Terms.
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        <h3>Provider Content</h3>
        <ol>
          <li>
            <p>Provider Content generally</p>
            <ol>
              <li>
                <p>
                  You represent, warrant and undertake to Avaana that all Provider Content posted, uploaded or supplied
                  to Avaana in connection with these Terms:
                </p>
                <ol>
                  <li>
                    <p>is true, accurate, current, and complete and not misleading or deceptive;</p>
                  </li>
                  <li>
                    <p>complies with these Terms;</p>
                  </li>
                  <li>
                    <p>is not contrary to the Community Guidelines;</p>
                  </li>
                  <li>
                    <p>
                      is not illegal and will not constitute or encourage any contravention of any Applicable Laws by
                      any person;
                    </p>
                  </li>
                  <li>
                    <p>does not violate any other entity's Intellectual Property Rights; and</p>
                  </li>
                  <li>
                    <p>is capable of being validly and irrevocably licensed to Avaana as set out in clause 2.1(c).</p>
                  </li>
                </ol>
              </li>

              <li>
                <p>
                  All Provider Content stored on the Platform is owned by the Provider and not Avaana. You are solely
                  responsible for all Provider Content that you upload on the Platform or which is capable of being
                  transmitted through the Platform to Site Users.
                </p>
              </li>
              <li>
                <p>
                  You acknowledge and agree that upon uploading any Provider Content to the Platform, you hereby
                  unconditionally and irrevocably grant (or represent and warrant that the owner of such rights has
                  expressly unconditionally and irrevocably granted) to Avaana, a worldwide, royalty-free, perpetual and
                  non-exclusive licence to use, reproduce, copy, adapt, store, distribute, print, display, perform,
                  broadcast, publish, communicate to the public, make available to the public or create derivative works
                  of such Provider Content anywhere, for any purpose and in any form, without any compensation to you.
                  Avaana will discontinue this licensed use within a commercially reasonable period after such Provider
                  Content is removed from the Platform.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Photographs</p>
            <ol>
              <li>
                <p>
                  You should only upload photographs to the Platform which have been taken at your own venue or which
                  are of you or your Practitioners and must ensure that you have the right to use any photographs which
                  are uploaded to the Platform.
                </p>
              </li>
              <li>
                <p>
                  If you do not have any photographs available to upload, Avaana reserves the right to upload suitable
                  photographs for the purposes of your Provider Page and otherwise in connection with your Account or
                  use of the Avaana Services.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Avaana’s rights in relation to the Provider Content</p>
            <p>You hereby grant Avaana the right to:</p>
            <ol>
              <li>
                <p>
                  use, reproduce, copy, adapt, store, distribute, print, display, perform, broadcast, publish,
                  communicate to the public, make available to the public or create derivative works of your Provider
                  Content anywhere, for any purpose and in any form, without any compensation to you including in
                  connection with the Platform, the Channels and the provision of Avaana Services;
                </p>
              </li>
              <li>
                <p>
                  refuse to do any of the things specified in clause 2.3(a) in respect of any Provider Content without
                  giving any reason;
                </p>
              </li>
              <li>
                <p>
                  remove, edit, cut-down or otherwise amend Provider Content (including Provider Content which is to be
                  published on your Provider Page), including where such Provider Content does not, in Avaana’s
                  reasonable opinion comply with the Community Guidelines;
                </p>
              </li>
              <li>
                <p>
                  amend the Service Price for any Provider Service offered or advertised on the Platform such that it
                  complies with clause 3.3; or
                </p>
              </li>
              <li>
                <p>
                  make use of search engine optimisation services, Channels and other mechanisms that embody,
                  incorporate or quote (in whole or part) the trading name of the Provider, any brands used in
                  connection with the Provider Services, images, logo, video and other content comprising the Provider
                  Content.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Backup</p>
            <p>
              Avaana encourages you to keep a back-up copy of any of your Provider Content. In no event will Avaana be
              liable for the deletion, loss, or modification of any Provider Content.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>Appointments</h3>
        <ol>
          <li>
            <p>Provision of Avaana Services</p>
            <p>
              In consideration of the payment by you of the Fees and Third Party Fees set out in clause 4 and the
              performance of your obligations under these Terms, Avaana agrees to provide to you one or more of the
              applicable Avaana Services which includes the ability to advertise and sell Provider Services using the
              Marketplace Service.
            </p>
          </li>
          <li>
            <p>Agent for Bookings</p>
            <p>
              In respect of all Provider Services advertised by you on the Platform, Avaana shall act and is hereby
              appointed by you as the Provider’s agent to:
            </p>
            <ol>
              <li>
                <p>accept and conclude Bookings (including Appointments) with Clients;</p>
              </li>
              <li>
                <p>manage cancellations of Appointments and assist with rescheduling of Appointments; and</p>
              </li>
              <li>
                <p>
                  except where the Pay By Cash Option is used by a Client, collect and process payments on behalf of the
                  Provider.
                </p>
              </li>
            </ol>
            <p>
              Nothing in these Terms shall prevent or limit you from remaining fully responsible and liable for the
              performance, provision or supply of Provider Services to Clients.
            </p>
          </li>
          <li>
            <p>Pricing of Provider Services</p>
            <ol>
              <li>
                <p>
                  You must at all times supply the Provider Services through the Marketplace Service at a price which is
                  the same as or more affordable to the Client than the best available price offered to the general
                  public at your own venue (or other place where the Provider Services are performed) or on your own
                  website.
                </p>
              </li>
              <li>
                <p>
                  If a Client provides proof of a better price available to the general public at your own venue (or
                  other place where the Provider Services are performed) or on your own website for Provider Services
                  booked through the Marketplace Service, Avaana reserves the right to refund the Client the difference
                  and reduce the amount paid to the Provider in connection with those Provider Services accordingly.
                </p>
              </li>
              <li>
                <p>
                  The Provider acknowledges and agrees that Avaana may offer Promo Codes to Site Users and Clients in
                  connection with their use of the Platform, which they may apply or redeem in connection with the
                  purchase of Provider Services. The redemption of a Promo Code by any Client against a Booking will not
                  effect:
                </p>
                <ol>
                  <li>
                    <p>
                      the calculation of any Fees or Third Party Fees due and payable by the Provider to Avaana in
                      accordance with clause 4; or
                    </p>
                  </li>
                  <li>
                    <p>
                      the balance of any Provider Fees payable to Providers (after the deduction of any Fees or Third
                      Party Fees payable to Avaana) in accordance with clause 4.
                    </p>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <p>Appointment Availability</p>
            <ol>
              <li>
                <p>
                  You are solely responsible for ensuring that the information on each Practitioner’s Calendar regarding
                  the time and date availability of the Practitioner to accept Appointments is kept up to date at all
                  times, so that potential Clients are able to view the accurate time and date availability at the time
                  of making an Appointment.
                </p>
              </li>
              <li>
                <p>
                  The Platform may use integration tools (Integration Tools) to assist Providers to synchronise the time
                  and date availability of their Practitioners in accordance with clause 3.4 (a), and:
                </p>
                <ol>
                  <li>
                    <p>
                      you agree and acknowledge that an Integration Tool may not be available for use by you, in which
                      case, the Calendar may need to be used to manage time and date availability for the purposes of
                      complying with your obligations under these Terms;
                    </p>
                  </li>
                  <li>
                    <p>
                      even if an Integration Tool is available for your use, Avaana does not represent or warrant that
                      the Integration Tool will provide uninterrupted, timely, secure, or error-free information to
                      Avaana or the Platform regarding your time and date availability and we shall not be responsible
                      for any Loss whatsoever incurred by you as the result of:
                    </p>
                    <ol>
                      <li>
                        <p>
                          the failure of any Integration Tool to properly or accurately upload your time and date
                          availability on to the Platform; or
                        </p>
                      </li>
                      <li>
                        <p>
                          any requirement to obtain the approval of any licensor of any practice management software or
                          system;
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p>
                      the use of an Integration Tool does not in any way limit your obligations under clause 3.4(a).
                    </p>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <p>Acceptance of Appointment and performance of Provider Services</p>
            <ol>
              <li>
                <p>
                  You acknowledge and agree that Avaana is a real-time online appointment booking platform and that an
                  Appointment is automatically accepted by Avaana as agent for the Provider at the time and date
                  selected for the Appointment by the Client via the Marketplace Service.
                </p>
              </li>
              <li>
                <p>
                  You acknowledge that failure by you or any of your Practitioners to honour an Appointment at the time
                  and date selected by the Client may result in significant financial and reputational damage to Avaana
                  and that, subject to clause 3.6, may result in the forfeiture by you of any Provider Fees due to you
                  in connection with these Terms in respect of such Appointment.
                </p>
              </li>
              <li>
                <p>
                  Following notification of an Appointment to you, you will be responsible for confirming receipt of the
                  Appointment by email to Avaana within 4 working hours of receipt.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Cancelling and Rescheduling Appointments</p>
            <ol>
              <li>
                <p>
                  A Client must be able to cancel (and receive a full refund) or reschedule an Appointment up until 24,
                  48 or 72 hours before the time of the Appointment (such timeframe to be selected by you via your
                  Business Dashboard or in the absence of a selection, 48 hours) (Cancellation Policy).
                </p>
              </li>
              <li>
                <p>
                  Upon request, Avaana will offer and provide to a Client a refund for an Appointment which is cancelled
                  by the Client (and unable to be rescheduled) in accordance with your Cancellation Policy.
                </p>
              </li>
              <li>
                <p>
                  If a Client wishes to change the date and/or time of an Appointment, you must use your best endeavours
                  to offer the Client a suitable alternative booking time and/or date.
                </p>
              </li>
              <li>
                <p>
                  In the event that you are unable to fulfil an Appointment after a request by the Client to change the
                  date and/or time of the Appointment, Avaana will treat the Appointment as cancelled by the Client and
                  if cancelled in accordance with your Cancellation Policy, will refund the Client the amount paid by
                  the Client in respect of the Appointment.
                </p>
              </li>
              <li>
                <p>
                  You may only reschedule an Appointment with a Client in exceptional circumstances (such circumstances
                  to be reasonably determined by Avaana). If you wish to change the date and/or time of an Appointment
                  in such exceptional circumstances, in the event that the Client is unable or unwilling to agree to
                  such change, Avaana will treat the Appointment as cancelled by you and will refund the Client the full
                  value of the Appointment. However, Avaana will still require you to pay the applicable Fees and Third
                  Party Fees that would have been due from you in respect of that Appointment. For the avoidance of
                  doubt, the fact that you may have another appointment booked at the same time and date of the
                  Appointment, does not constitute exceptional circumstances for the purposes of this clause 3.6(e).
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Vouchers</p>
            <ol>
              <li>
                <p>
                  If you sell any of the types of Provider Services described in clause 3.7(d), those specific goods and
                  services will be advertised for sale and may be purchased through our Platform by way of Voucher.
                </p>
              </li>
              <li>
                <p>
                  Unless otherwise agreed between you and the Client, a Voucher (and your associated obligation to
                  perform the Provider Services or provide the goods or services the subject of the Voucher) expires at
                  5:00pm Australian Eastern Standard Time on the date that is 12 months from the date of the Client’s
                  purchase of the Voucher.
                </p>
              </li>
              <li>
                <p>
                  You are responsible for contacting a Client who purchases a Voucher for your Provider Services in
                  order to organise the redemption of the Voucher.
                </p>
              </li>
              <li>
                <p>You must:</p>
                <ol>
                  <li>
                    <p>
                      if the relevant Provider Services the subject of the Voucher is a multiple appointment or multiple
                      session pack (other than Provider Services specified under clause 3.7(d)(2)), use its best
                      endeavours to accommodate the time(s) and date reasonably requested by the Client in relation to
                      the redemption(s) of their Voucher.
                    </p>
                  </li>
                  <li>
                    <p>
                      if the relevant Provider Services the subject of the Voucher is a group class or group session (or
                      a pack of group classes or group sessions), to the extent that the information is not on your
                      website or has not otherwise been provided to Avaana, you must provide Avaana with all reasonable
                      details in relation to the date(s) and time(s) pursuant to which the Client can redeem the
                      Voucher.
                    </p>
                  </li>
                  <li>
                    <p>
                      if the relevant Providers Services the subject of the Voucher is a product or goods, securely
                      deliver the Product to the Client’s address (as notified to you by Avaana) within 7 Business Days
                      of the purchase of the Voucher. For the avoidance of doubt, Avaana does not bear any liability in
                      connection with the delivery of such products to the relevant Client.
                    </p>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <p>No Shows</p>
            <ol>
              <li>
                <p>
                  In respect of Appointments made using the Pay By Cash Option, the Marketplace Commission and Third
                  Party Fees (if any) shall be payable for all such Appointments except where you have notified Avaana
                  within 24 hours of the date the Appointment was booked for, indicating that the Client has not arrived
                  for their Appointment as scheduled (No Show).
                </p>
              </li>
              <li>
                <p>
                  For the avoidance of doubt, if a No Show has not been notified to Avaana by email to
                  providers&#64;avaana.com.au within 24 hours of the time and date of the Appointment, the Appointment will
                  be treated by Avaana as fulfilled and Avaana shall be entitled to receive the applicable Fees and
                  Third Party Fees in respect of that Appointment.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Performance of Provider Services</p>
            <ol>
              <li>
                <p>
                  In the case of an Appointment, you must provide the relevant Provider Services to the Client at the
                  specified date and time selected by the Client for the Appointment.
                </p>
              </li>
              <li>
                <p>
                  In the case of all Bookings, you must provide the relevant Provider Services to the Client to the
                  highest industry standards.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Fair Use of the Avaana Services</p>
            <ol>
              <li>
                <p>
                  You shall not solicit Site Users or Clients to make Bookings otherwise than through the Platform or
                  Channels (as applicable).
                </p>
              </li>
              <li>
                <p>
                  Where a Client makes a Booking and you encourage that Client to cancel their Booking and make a
                  separate booking directly with you, you shall be in breach of these Terms.
                </p>
              </li>
              <li>
                <p>
                  If Avaana has reasonable grounds to suspect that you have made any direct or indirect attempt to avoid
                  paying any Fees or Third Party Fees, for example by fraudulently indicating that the Appointment
                  fulfilled using the Pay By Cash Option as a No Show, you will be in breach of these Terms and shall
                  give Avaana the right, without limiting other remedies available to it, to withhold and retain any
                  payments due to the Provider under these Terms.
                </p>
              </li>
              <li>
                <p>You must not use the Platform to:</p>
                <ol>
                  <li>
                    <p>
                      post or upload advertisements for competitors of Avaana or post Provider Content or other content
                      that contains links to any Platform competitive with Avaana;
                    </p>
                  </li>
                  <li>
                    <p>
                      except for Premium Providers, post or upload any information in a manner designed to encourage the
                      Client to make a separate booking for Provider Services or to otherwise purchase goods or services
                      advertised for sale by you, other than through the Marketplace Service (for example, including
                      your business telephone number, website, email address or other contact information in your
                      business profile or practitioner profile published on your Provider Page);
                    </p>
                  </li>
                  <li>
                    <p>advertise sexual services or seek individuals for Bookings of a sexual nature.</p>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <p>No representations</p>
            <ol>
              <li>
                <p>
                  Avaana makes no representations, warranties or undertakings to you except as expressly set out in
                  these Terms and without limiting the foregoing:
                </p>
                <ol>
                  <li>
                    <p>
                      Avaana does not represent that you will receive any Booking via the Marketplace Service or that
                      Avaana will assist you to fill empty appointment slots or generate revenue.
                    </p>
                  </li>
                  <li>
                    <p>
                      Where a Client successfully secures an Appointment where the Client chooses to pay for the
                      Provider Service using the Pay By Cash Option, Avaana makes no guarantee or representation as to
                      the financial standing of the Client or the Client’s capacity to pay for the Provider Services.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  There are risks in dealing with strangers. You assume all risks associated with dealing with Clients
                  with whom you come in contact through the Platform.
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        <h3>Payments and Fees</h3>
        <ol>
          <li>
            <p>Payment of Fees to Avaana</p>
            <p>
              In consideration of the performance by Avaana of the Avaana Services, if you are a Provider, you must pay
              any and all Fees and Third Party Fees applicable to your use of the Avaana Services in accordance with
              this clause 4.
            </p>
          </li>
          <li>
            <p>Marketplace Commission</p>
            <ol>
              <li>
                <p>If you are a Provider, you must pay to Avaana:</p>
                <ol>
                  <li>
                    <p>the Marketplace Commission; and</p>
                  </li>
                  <li>
                    <p>
                      all Third Party Fees, in respect of each Booking by a Client for Provider Services through the
                      Marketplace Service (Marketplace Booking), in accordance with Avaana’s Standard Payment Terms.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>The Marketplace Commission for a Marketplace Booking shall be calculate das the greater of:</p>
                <ol>
                  <li>
                    <p>
                      The Commission Rate multiplied by the Service Price for the relevant Provider Service the subject
                      of the Marketplace Booking (and for the avoidance of doubt, not the Checkout Price paid by the
                      Client); and
                    </p>
                  </li>
                  <li>The Minimum Fee.</li>
                </ol>
              </li>
              <li></li>
            </ol>
          </li>
          <li>
            <p>Premium Fees</p>
            <p>
              If you are a Premium Provider, you must pay to Avaana the Premium Subscription Fees monthly in advance.
            </p>
          </li>
          <li>
            <p>Collection of Provider Fees</p>
            <ol>
              <li>
                <p>
                  You acknowledge and agree that Avaana may collect all Provider Fees payable to you in respect of
                  Bookings. You agree that successful receipt of payment by Avaana will discharge a Client’s debt to you
                  for Provider Services.
                </p>
              </li>
              <li>
                <p>
                  You acknowledge and agree that Avaana may collect payment for all of Our Invoices for Fees and Third
                  Party Fees by way of deduction from the Provider Fees payable to the Provider in respect of Bookings.
                </p>
              </li>
              <li>
                <p>Without limiting clause 4.4 (b), Avaana reserves the right to deduct:</p>
                <ol>
                  <li>
                    <p>
                      any sums payable to Avaana by the Provider including any unpaid amounts payable to Avaana pursuant
                      to clause 4.5 (c); and
                    </p>
                  </li>
                  <li>
                    <p>
                      any refunds or chargebacks relating to Bookings, from any balance collected by Avaana on behalf of
                      the Provider, prior to onward payment of the balance of any Provider Fees due to the Provider in
                      accordance with clause 4.5.
                    </p>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <p>Invoicing and payment</p>
            <ol>
              <li>
                <p>
                  Avaana will use its best endeavours to issue Our Invoice to the Provider on the 28th of each calendar
                  month (the Invoice Statement) which will set out:
                </p>
                <ol>
                  <li>
                    <p>Any balance carried forward from the last Invoice Statement, if any;</p>
                  </li>
                  <li>
                    <p>
                      what Avaana owes the Provider in respect of Bookings in the period since the last Invoice
                      Statement, if any;
                    </p>
                  </li>
                  <li>
                    <p>
                      what the Provider owes Avaana in respect of Fees and Third Party Fees in the period since the last
                      Invoice Statement, such amounts to be deducted from any amount owed to the Provider pursuant to
                      4.5 (a) (2) above, if any; and
                    </p>
                  </li>
                  <li>
                    <p>
                      the resulting account balance (the Closing Balance) payable either by Avaana to the Provider or
                      the Provider to Avaana.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  If the Closing Balance results in an amount payable to the Provider, Avaana will transfer the Closing
                  Balance to the Provider within 3 to 5 Business Days of the date of the Invoice Statement and no
                  further action in respect of that Invoice Statement will be required by the Provider.
                </p>
              </li>
              <li>
                <p>
                  If the Closing Balance results in an amount payable to Avaana, the Partner will be required to
                  transfer the Closing Balance to Avaana in accordance with our Standard Terms to the bank account
                  details listed in the Invoice Statement.
                </p>
              </li>
              <li>
                <p>
                  If the Closing Balance results in an amount payable to Avaana, the Partner will be required to
                  transfer the Closing Balance to Avaana in accordance with our Standard Terms to the bank account
                  details listed in the Invoice Statement.
                </p>
              </li>
              <li>
                <p>
                  If the Closing Balance is zero, the Invoice Statement will state that the Closing Balance is settled
                  and there is nothing further for Avaana or the Provider to do in respect of that Invoice Statement.
                </p>
              </li>
              <li>
                <p>
                  All payments due from Avaana to the Provider shall be made via bank transfer using the bank details
                  provided by the Provider to Avaana in its Signup Form or Business Dashboard and it is the Provider’s
                  responsibility to ensure that these details are correct. Avaana will only make payments due to the
                  Provider directly to the Provider and cannot make payments to any third party.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Payment Gateway Fees</p>
            <p>
              Payment processing services for Providers on the Platform are provided by Stripe and are subject to the
              Stripe Connected Account Agreement, which includes the Stripe Terms of Service (collectively, the Stripe
              Services Agreement). By agreeing to these Terms or continuing to operate as a Provider on the Platform,
              you agree to be bound by the Stripe Services Agreement, as the same may be modified by Stripe from time to
              time. As a condition of Avaana enabling payment processing services through Stripe, you agree to provide
              Avaana accurate and complete information about you and your business, and you authorize Avaana to share it
              and transaction information related to your use of the payment processing services provided by Stripe.
            </p>
          </li>
          <li>
            <p>API Fees</p>
            <p>
              In addition to the Fees, you agree to pay Avaana all transaction costs and fees incurred by Avaana in
              connection with any API Information obtained by Avaana at the time of the making of a Booking including in
              connection with the Integration Tools pursuant to clause 3.4(b) (API Fees).
            </p>
          </li>
          <li>
            <p>Amendments to Fees</p>
            <ol>
              <li>
                <p>
                  You acknowledge that Avaana may amend the Fees and the Third Party Fees (including, without
                  limitation, adding a new fee or charge or replacing an existing fee or charge) at any time by notice
                  to you ( Pricing Change). Your continued use of the Platform and the Avaana Services following either
                  form of notification will represent an agreement by you to be bound by the Fees and the Third Party
                  Fees as amended by the Pricing Change.
                </p>
              </li>
              <li>
                <p>
                  If as a result of a Pricing Change, you wish to change the Avaana Services you receive, you must
                  provide written notice to Avaana to this effect within 14 days of the Pricing Change in order to
                  prevent the Pricing Change coming into effect for that Provider.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Tax</p>
            <p>
              All Fees, Third Party Fees and payments are, unless otherwise stated, inclusive of GST (as defined under a
              New Tax System (Goods and Services Tax) Act 1999 (Cth)) (GST).
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>Interaction with Clients</h3>
        <ol>
          <li>
            <p>Confidential Information and Personal Information</p>
            <ol>
              <li>
                <p>
                  You must keep all Client Content and information in respect of Bookings confidential and only disclose
                  Confidential Information the subject of a Booking to persons within your business who have a need to
                  know such information.
                </p>
              </li>
              <li>
                <p>
                  You acknowledge that all Client Information provided to you in respect of a Client is Personal
                  Information and is confidentially provided to you for the sole purpose of enabling you to provide the
                  Provider Services to the relevant Client.
                </p>
              </li>
              <li>
                <p>
                  You must comply with the Privacy Act with respect to the collection, use, disclosure, accuracy,
                  security and openness of all Personal Information collected by you in connection with these Terms.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Communications with Clients and complaints</p>
            <ol>
              <li>
                <p>All communications with Clients should be in accordance with the Community Guidelines.</p>
              </li>
              <li>
                <p>
                  You must promptly deal with any enquiries, matters or issues relating to Bookings or potential
                  Bookings including dealing with Client complaints.
                </p>
              </li>
              <li>
                <p>
                  You are fully responsible and liable for the performance, provision or supply of your Provider
                  Services to Clients and Avaana is in no way liable to Clients for the Provider Services they receive
                  from you.
                </p>
              </li>
              <li>
                <p>
                  Avaana shall refer any Client complaints it receives to you and you shall acknowledge all complaints,
                  and shall respond to the relevant Client within 48 hours of your receipt of a complaint (whether the
                  complaint has come directly from the Client or via Avaana).
                </p>
              </li>
              <li>
                <p>
                  You shall make all efforts to reach a resolution to any complaints within 14 days and must notify
                  Avaana of any correspondence between you and the Client relating to the complaint and generally keep
                  Avaana apprised of its progress and the status of the complaint.
                </p>
              </li>
              <li>
                <p>
                  If Avaana considers it to be fair in all the circumstances given the nature and of the complaint,
                  Avaana may at our sole discretion elect to:
                </p>
                <ol>
                  <li>
                    <p>
                      give the Client a Promo Code for the value of the disputed/complained about amount of the Booking;
                      or
                    </p>
                  </li>
                  <li>
                    <p>
                      as a last resort or in extreme circumstances and always at our sole discretion refund the
                      disputed/complained about amount directly to the Client, in which case, we will charge the value
                      of the disputed/complained about the subject of the Promo Code or refund, from you.
                    </p>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <p>Client Reviews</p>
            <ol>
              <li>
                <p>
                  You hereby acknowledge and accept that the Platform includes a reviewing platform, upon which Clients
                  may post publicly viewable reviews about their experiences with Avaana and with you and your business
                  (particularly in connection with the Provider Services) (Client Reviews).
                </p>
              </li>
              <li>
                <p>
                  To the maximum extent permitted by law, you shall be directly responsible to any professional or
                  regulatory bodies of which you are a member, which prohibit the Provider from being the subject of, or
                  soliciting Client Reviews or testimonials.
                </p>
              </li>
              <li>
                You acknowledge and agree that you may from time to time be subject to negative Client Reviews and/or
                feedback from consumers, which is outside of Avaana’s control.
              </li>
              <li>
                For the avoidance of doubt, you shall have no right to any remedy as a result of any Client Review
                naming or referring to the Provider. However, if you, acting reasonably, feels that any Client Review is
                defamatory of the Provider or any person or in some other way is a violation of any person’s legal
                rights, you may report that Client Review to Avaana by email to providers&#64;avaana.com.au. In such case,
                Avaana shall review the same and in its sole discretion take any action it deems necessary or desirable
                (including, for example, removing or amending the relevant piece of Client Review).
              </li>
            </ol>
          </li>
          <li>
            <p>Acknowledgement</p>
            <ol>
              <li>
                <p>
                  Avaana makes no representations in relation to any Client Content, Provider Content or information
                  available on or otherwise provided to you through the Platform.
                </p>
              </li>
              <li>
                <p>
                  While Avaana reserves the right in its absolute discretion to remove Provider Content, Client Content
                  or other material from the Platform from time to time, Avaana does not assume any obligation to do so
                  and to the extent permitted by law, disclaims any liability for failing to take any such action.
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        <h3>The Platform and the Software Services</h3>
        <ol>
          <li>
            <p>Limited licence</p>
            <p>
              In consideration of the payment to Avaana of the Fees and you performing all of your other obligations
              under these Terms, Avaana grants to you a personal, non-exclusive, non-transferable and fully revocable
              licence to use the applicable Software Services in accordance with this clause 6.
            </p>
          </li>
          <li>
            <p>Use</p>
            <ol>
              <li>
                <p>
                  You may use the applicable Software Services for the purpose of processing and scheduling bookings of
                  Provider Services for and on behalf of yourself only.
                </p>
              </li>
              <li>
                <p>
                  By accessing and using the Platform or the Software Services, you assume all risks associated with
                  such access and use.
                </p>
              </li>
              <li>
                <p>
                  The Platform is provided to you on an “as is, as available” and “with all faults” basis and without
                  warranties or representations of any kind either express or implied. You have no right to technical
                  support in respect of the Software Services but Avaana will attempt to assist you by email, should any
                  technical issues arise in connection with your use of the Software Services.
                </p>
              </li>
              <li>
                <p>
                  To the fullest extent permitted by law, Avaana does not represent or warrant that the Platform or the
                  products and/or services generally available through the Platform will be uninterrupted or error-free
                  or defect-free or that errors or defects in the Platform will be corrected. Avaana does not represent
                  or warrant to you that any electronic files available through the Platform will be free of Harmful
                  Code or that your use of the Platform will achieve any particular results.
                </p>
              </li>
              <li>
                <p>
                  You understand and accept that Avaana uses third party vendors and hosting partners to provide the
                  hardware, software, networking, storage, and related technology required to run the Software Services.
                  You also acknowledge and agree that Avaana shall have administrator’s access to all parts of the
                  Software Services, including those parts that have been specifically designed for use by you.
                </p>
              </li>
              <li>
                <p>
                  You shall not reproduce, duplicate, copy, sell, resell or exploit the whole or any part of the
                  Software Services, or allow any third party (including group companies of the Provider) to use or
                  access the Software Services without express prior written permission from Avaana (which may be denied
                  or granted on such terms as Avaana in its sole discretion may determine).
                </p>
              </li>
              <li>
                <p>
                  Avaana makes no claims or representations that the Platform may be lawfully accessed and used outside
                  of Australia. The use of the Platform may not be legal by certain persons or in certain countries. If
                  you access the Platform from outside of Australia, you do so at your own risk and are responsible for
                  compliance with the Applicable Laws.
                </p>
              </li>
              <li>
                <p>Avaana does not warrant:</p>
                <ol>
                  <li>
                    <p>that the Software Services will meet your specific requirements;</p>
                  </li>
                  <li>
                    <p>
                      that the Software Services will be uninterrupted, timely, secure, error-free or free of Harmful
                      Code;
                    </p>
                  </li>
                  <li>
                    <p>
                      that any information or results that may be obtained from the use of the Software Services will be
                      accurate or reliable;
                    </p>
                  </li>
                  <li>
                    <p>
                      that the quality of any products, services, information, or other material purchased or obtained
                      by you through the Software Services will meet your requirements or expectations; or
                    </p>
                  </li>
                  <li>
                    <p>that any errors in the Software Services will be corrected.</p>
                    <ol>
                      <li>
                        <p>
                          You agree that in respect of your use of the Software Services, to the maximum extent
                          permitted by Applicable Laws, Avaana shall not be liable for any Loss including of income or
                          profits, loss of contracts, loss of goodwill, loss of data, or other tangible or intangible
                          losses or for any indirect or consequential loss or damage (even if Avaana has been advised by
                          you of the possibly of such loss or damage) resulting from:
                        </p>
                        <ol>
                          <li>
                            <p>your use of, or inability to use, the Software Services;</p>
                          </li>
                          <li>
                            <p>unauthorised access to or alteration of your transmissions or data;</p>
                          </li>
                          <li>
                            <p>statements or conduct of any third party in connection with the Software Services; or</p>
                          </li>
                          <li>
                            <p>any other matter relating to the Software Services.</p>
                          </li>
                        </ol>
                      </li>
                      <li>
                        <p>
                          Avaana does not represent or warrant that the information on the Platform is current, fit for
                          the purpose for which the content is downloaded and does not infringe upon the rights of
                          others.
                        </p>
                      </li>
                      <li>
                        <p>
                          You are responsible for your use of any information or materials obtained from the Platform.
                          You should make your own enquiries to check if the information on the Platform is accurate,
                          complete and suitable for your intended use.
                        </p>
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <p>Acknowledgements</p>
            <ol>
              <li>
                <p>
                  You acknowledge that despite all reasonable precautions on our part, there is a risk of unauthorised
                  access to, or alteration of, your transmissions of data or of information contained on your computer
                  system or on the Platform. To the maximum extent permitted by law, Avaana accepts no liability for any
                  Loss which you may suffer or incur as a result of such activity.
                </p>
              </li>
              <li>
                <p>
                  Nothing in these Terms will impose a duty of care upon Avaana in respect of your use of the Platform.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              Platform modifications Avaana reserves the right to make any changes to the Software Services and the
              Avaana Services as are considered necessary or desirable, at any time, without notice.
            </p>
          </li>
          <li>
            <p>Disable Platform</p>
            <ol>
              <li>
                <p>
                  Avaana reserves the right, at any time, to disable, close or render inaccessible the Platform (or
                  parts of the Platform) for so long as Avaana desires for any reason whatsoever, and without the need
                  to provide any reasons.
                </p>
              </li>
              <li>
                <p>
                  To the maximum extent permitted by law, Avaana does not accept liability for any Loss which a Provider
                  or its Practitioners may suffer or incur as a result of such actions.
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        <h3>Applicable Laws</h3>
        <ol>
          <li>
            <p>Lawful use</p>
            <ol>
              <li>
                <p>
                  You must use the Platform and the Avaana Services for lawful purposes only and ensure that all access
                  to, or use of, the Platform or the Avaana Services by you and your Practitioners is not illegal or
                  prohibited by law. It is your responsibility to obtain legal, financial, accounting and other
                  professional advice in relation to compliance with all Applicable Laws in using the Platform. You
                  agree at all times to deal with any information or material provided by Avaana or accessed through the
                  Platform in a manner which complies with all Applicable Laws.
                </p>
              </li>
              <li>
                <p>
                  You warrant, represent and undertake that you shall comply with all Applicable Laws and advertising
                  regulations in the marketing, sale and provision of the Provider Services and shall obtain all
                  licences, consents, authorities and insurance it is either necessary or reasonably prudent for you to
                  obtain in respect of all of your business activities and personnel (but especially in connection with
                  the provision of Provider Services).
                </p>
              </li>
              <li>
                <p>
                  Unless otherwise stated, you are permitted to download content which is clearly contemplated for
                  download from the Platform for personal use only, subject to the maintenance of the integrity of any
                  copyright, trademark or other proprietary notices or material. You may not sell, redistribute or use
                  the content of the Platform for any commercial purpose. Avaana does not permit any copy, modification,
                  alteration, distribution, sale, broadcast or transmission of any downloaded material.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Misuse and interference</p>
            <p>You must not:</p>
            <ol>
              <li>
                <p>(a) attempt to gain unauthorised access to any part of the Platform or the Software Services;</p>
              </li>
              <li>
                <p>
                  (b) interfere with or disrupt (or attempt to interfere or disrupt) any servers or networks connected
                  to the Platform or the integrity or performance of the Platform or the Software Services;
                </p>
              </li>
              <li>
                <p>(c) disable any protection software associated with the Platform or the Software Services;</p>
              </li>
              <li>
                <p>(d) send or store any Harmful Code when using the Platform or the Software Services;</p>
              </li>
              <li>
                <p>
                  (e) use any data mining, robots or similar data gathering or extraction methods on the Platform or the
                  Software Services;
                </p>
              </li>
              <li>
                <p>(f) reverse engineer or decompile any parts of the Platform or the Software Services;</p>
              </li>
              <li>
                <p>
                  (g) except with the prior consent of Avaana, frame or link to any Avaana content or information
                  available on the Platform or the Software Services;
                </p>
              </li>
              <li>
                <p>(h) misuse any content that appears on the Platform, in any way;</p>
              </li>
              <li>
                <p>
                  (i) use any feature of the Platform in a manner that Avaana reasonably determines is inappropriate or
                  not intended or is otherwise in breach of the Community Guidelines; or
                </p>
              </li>
              <li>
                <p>(j) assign your rights or obligations under these Terms.</p>
              </li>
            </ol>
          </li>
          <li>
            <p>Intellectual Property Rights</p>
            <ol>
              <li>
                <p>
                  Except for the Provider Content and subject to clause 7.3(b), all Intellectual Property Rights in the
                  materials found on the Platform or the Software Services (including source code, object code, text,
                  graphics, logos, icons, sound recordings and software) is owned by Avaana or third parties.
                </p>
              </li>
              <li>
                <p>
                  Material procured from a third party may be the subject of copyright owned by that third party. Except
                  as expressly authorised and subject to the conditions prescribed under the Copyright Act 1968 (Cth) or
                  except as expressly permitted by these Terms or the relevant copyright owner or licensor, you may not,
                  in any form or by any means:
                </p>
                <ol>
                  <li>
                    <p>
                      copy, adapt, reproduce, store, distribute, print, display, perform, publish, communicate to the
                      public, make available to public or create derivative works of the whole or any part of the
                      materials the subject of copyright; or
                    </p>
                  </li>
                  <li>
                    <p>
                      commercialise the whole or any part of the materials the subject of copyright, without our express
                      written permission or, in the case of third party material, from the owner of the copyright in
                      that material.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  Except for any trademarks comprising the Provider Content or trademarks used on the Platform owned by
                  a third party, trademarks used on the Platform are Avaana’ s trademarks (registered or unregistered)
                  or trademarks of third parties. If you use any trademarks owned by Avaana, in reference to Avaana, the
                  Platform or the Avaana Services, you must include a statement attributing that trademark to Avaana.
                  You must not use any of our trademarks or trademarks of third parties featured on the Platform:
                </p>
                <ol>
                  <li>
                    <p>in, or as the whole or part of, your own trademarks;</p>
                  </li>
                  <li>
                    <p>in connection with any business, products or services which are not Avaana’s;</p>
                  </li>
                  <li>
                    <p>in a manner which may be confusing, misleading or deceptive to any person; or</p>
                  </li>
                  <li>
                    <p>in a manner that disparages Avaana, the third party owners of the trademarks or the Platform.</p>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        <h3>Indemnity</h3>
        <ol>
          <li>
            <p>Indemnity</p>
            <p>
              You indemnify and must keep indemnified Avaana, its officers, directors, employees, agents and contractors
              ( Those Indemnified) from and against any Loss of any kind which Those Indemnified suffer or incur arising
              out of or in direct or indirect connection with:
            </p>
            <ol>
              <li>
                <p>
                  any breach of these Terms by you or your Practitioners (including, without limitation, any warranty
                  given under these Terms) including any failure to pay Fees or Third Party Fees;
                </p>
              </li>
              <li>
                <p>
                  your access to, or use of, the Platform including in connection with any information you post or
                  upload to the Platform or any linked website or platform (including Stripe);
                </p>
              </li>
              <li>
                <p>
                  any decision or action taken by you in reliance on any information or materials on the Platform and
                  any linked website;
                </p>
              </li>
              <li>
                <p>any wilful misconduct by you;</p>
              </li>
              <li>
                <p>any or other negligent act or omission by you;</p>
              </li>
              <li>
                <p>
                  any Claim against Those Indemnified by any third party (including Clients) relating to the supply of
                  the API Information through the Integration Tools;
                </p>
              </li>

              <li>
                <p>
                  any Claim against Those Indemnified by any third party (including Clients) relating to an allegation
                  or finding that use of the Integration Tools or the API Information infringes the Intellectual
                  Property Rights of any third party;
                </p>
              </li>
              <li>
                <p>
                  any Claim against Those Indemnified brought by any Client or third party relating to the Provider
                  Services provided (or not provided), or actions (or failure to act), of you or any person (other than
                  Avaana) acting on your behalf;
                </p>
              </li>
              <li>
                <p>
                  any Claim against Those Indemnified for any failure to fulfil the Client’s expectations or for any
                  other legal liability which arises in respect of the Provider Services including any illness or injury
                  suffered by any Client directly or indirectly in connection with the performance you or the
                  Practitioners of Provider Services or otherwise suffered at the Provider’s venue or other place of
                  performance of the Provider Services;
                </p>
              </li>
              <li>
                <p>
                  any Claim against Those Indemnified in connection with the quality, length, safety or legality of any
                  Provider Service;
                </p>
              </li>
              <li>
                <p>
                  any Claim against Those Indemnified in connection with the ability of the Provider or a Practitioner
                  to properly service the needs and requirementsof Clients; and
                </p>
              </li>
              <li>
                <p>
                  any Claim against Those Indemnified brought by any governmental, state, or local agencies or arising
                  from any failure by you to comply with all Applicable Laws in relation to your use of the Platform any
                  professional or regulatory bodies of which you are a member, which prohibit you from being the subject
                  of, or soliciting Client Reviews or testimonials.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Third Party Beneficiaries</p>
            <p>
              You acknowledge that Avaana enters into these Terms for its own benefit but also as an agent for the
              benefit and on behalf of each of its officers, directors and employees (each an Indemnified Third Party
              and, collectively, the Indemnified Third Parties) and that the rights in respect of indemnification set
              out in clause 8.1 shall be rights and benefits of each such Indemnified Third Party (as if, in each case,
              a party to these Terms in its own right). Such rights shall be enforceable under these Terms by Avaana as
              agent for each such Indemnified Third Party. Notwithstanding the foregoing, Avaana may amend any provision
              of these Terms without the consent of any of the Indemnified Third Parties, even if that amendment affects
              or will affect the rights conferred on any Indemnified Third Party hereunder.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>Limitation of Liability</h3>
        <ol>
          <li>
            <p>Limitation of Liability</p>
            <ol>
              <li>
                <p>
                  To the maximum extent permitted by law, Avaana’s liability under any guarantee, condition or warranty
                  (including, without limitation, any guarantee, condition or warranty of merchantability, acceptable
                  quality, fitness for purpose or fitness for disclosed result), or any other right or remedy, under any
                  legislation or implied into these Terms by any legislation (Statutory Warranties) is hereby excluded.
                  Where Avaana is liable under any Statutory Warranties, and any legislation avoids or prohibits
                  provisions in a contract excluding or modifying the application of, or exercise of, or liability
                  under, such Statutory Warranties, Avaana’s liability for any breach of such Statutory Warranties shall
                  be limited, at Avaana’s option, to one or more of the following:
                </p>
                <ol>
                  <li>
                    <p>if the breach relates to goods:</p>
                    <p>
                      the replacement of the goods or the supply of equivalent goods; the repair of such goods; the cost
                      of replacing the goods or of acquiring equivalent goods; or the cost of having the goods repaired;
                      and
                    </p>
                  </li>
                  <li>
                    <p>
                      if the breach relates to services: the supplying of the services again or the cost of having the
                      services supplied again. You acknowledge and agree that reliance by Avaana on this limitation of
                      liability is fair and reasonable in all the circumstances.
                    </p>
                  </li>
                </ol>
              </li>

              <li>
                <p>
                  To the maximum extent permitted by law and without limiting clause 9.1(a) or the other limitations on
                  Avaana’s liability to you as set out in these Terms, Avaana its officers, directors, employees, agents
                  and contractors do not accept any liability for, and you hereby release Avaana from any Claim in
                  relation to, any Loss howsoever caused (including through our negligence), suffered or incurred by you
                  arising out of or in any way related to:
                </p>
                <ol>
                  <li>
                    <p>
                      your access to or use of the Platform or any of the Avaana Services (including the Software
                      Service);
                    </p>
                  </li>
                  <li>
                    <p>
                      any errors, omissions, unavailability of or interruption to or in connection with the Platform
                      (including the Software Services), the Integration Tools or the Avaana Services (including the
                      Software Services);
                    </p>
                  </li>
                  <li>
                    <p>
                      any Provider Content and Client Content (or the truth or accuracy of Provider Content or Client
                      Content);
                    </p>
                  </li>
                  <li>
                    <p>
                      any errors, omissions, unavailability of or interruption to or in connection with the content
                      published on the Platform or in connection with the Avaana Services (including the Client Content
                      and the Provider Content) including any technical inaccuracies and typographical errors;
                    </p>
                  </li>
                  <li>
                    <p>
                      any errors, omissions, unavailability of or interruption to or from any third party platforms,
                      content or services that are directly or indirectly accessed (including through links) or used by
                      the Platform;
                    </p>
                  </li>
                  <li>
                    <p>
                      any Harmful Code infecting your systems or devices as a result of your use of or access to the
                      Platform;
                    </p>
                  </li>
                  <li>
                    <p>
                      any decision or action taken by you in reliance on any information or materials on the Platform
                      and any linked website;
                    </p>
                  </li>
                  <li>
                    <p>
                      any Claim brought against you by any governmental, state, or local agencies or arising from any
                      failure by you to comply with all Applicable Laws in relation to your use of the Platform, Client
                      Reviews or the performance of the Provider Services; and
                    </p>
                  </li>
                  <li>
                    <p>
                      any professional or regulatory bodies of which you are a member, which prohibit you from being the
                      subject of, or soliciting Client Reviews or testimonials.
                    </p>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <p>Third Parties</p>
            <p>
              Avaana provides links on the Platform to other third party websites which are subject to their own terms
              and conditions of use and privacy policies and over which Avaana has no control. Use of the links provided
              is entirely at your own risk and discretion. Avaana does not endorse any information on those linked sites
              or any associated organisation, product or services.
            </p>
          </li>
          <li>
            <p>Limitation of damages</p>
            <p>
              To the maximum extent permitted by law, Avaana and/or its affiliates’, contractors’, individuals’,
              agents’, or third-party Providers’, licensors’, or suppliers’ total liability to you for all damages,
              Losses, and causes of action arising out of or relating to these Terms or your use of the Platform or your
              interaction with Clients (whether in contract, tort including negligence, warranty, or otherwise), will
              not exceed the amount paid by you, if any, to Avaana during the twelve months immediately preceding the
              date of the claim or one hundred dollars, whichever is greater.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>These Terms</h3>
        <ol>
          <li>
            <p>Legally binding agreement with Avaana</p>
            <ol>
              <li>
                <p>
                  These Terms form a legally binding agreement between you and Avaana with effect from the Commencement
                  Date and apply to your respective access to, and use of the Platform and the Avaana Services.
                </p>
              </li>
              <li>
                <p>
                  In accessing or using the Platform or the Avaana Services, you acknowledge that you have read,
                  understood and agrees to be bound by these Terms, the Avaana Terms of Use and Booking Conditions and
                  also the Community Guidelines.
                </p>
              </li>
              <li>
                <p>
                  If you do not accept these Terms, then you must ensure that you and each Practitioner associated with
                  you does not access the Platform and must immediately cease to use the Avaana Services, other than in
                  your capacity as a Visitor or a Client.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Amendment to Terms</p>
            <p>
              Avaana reserves the right to amend these Terms at any time. Any amendments will be effective immediately
              upon notification on the Platform or to you. Continued use of the Platform following such notification
              will represent an agreement by you to be bound by these Terms as amended.
            </p>
          </li>
          <li>
            <p>Termination by Provider or Practitioner</p>
            <ol>
              <li>
                <p>You agree that your only remedy with respect to any dissatisfaction with:</p>
                <ol>
                  <li>
                    <p>the Platform or the Avaana Services;</p>
                  </li>
                  <li>
                    <p>these Terms;</p>
                  </li>
                  <li>
                    <p>the Avaana Terms of Use and Booking Conditions and the Community Guidelines;</p>
                  </li>
                  <li>
                    <p>any change in Fees or Third Party Fees;</p>
                  </li>
                  <li>
                    <p>any policy or practice of Avaana in operating the Platform; or</p>
                  </li>
                  <li>
                    <p>any content or information transmitted through the Platform including Provider Content,</p>
                  </li>
                </ol>
                <p>
                  is to provide notice of cancellation of your Provider Account by email to providers&#64;avaana.com.au.
                  Subject to clause 10.3 (b), these Terms will terminate on the date that is 14 days after Avaana
                  receives your notice of termination.
                </p>
              </li>
              <li>
                <p>
                  Termination of these Terms will not end those provisions that are capable of surviving and in
                  particular, you will remain liable to pay any Fees or Third Party Fees due and payable in relation to
                  the period prior to the effective date of termination of these Terms pursuant to clause 10.3(b).
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Termination of Premium Services</p>
            <p>
              Premium Provider may terminate the Premium Services at any time by email to Avaana at
              providers&#64;avaana.com.au.
            </p>
          </li>
          <li>
            <p>Termination by Avaana</p>
            <ol>
              <li>
                <p>
                  Avaana may, in its absolute discretion, suspend or terminate your access to all or any part of the
                  Platform, including if Avaana considers that you are in breach of any provision of these Terms, and
                  without the need to provide reasons.
                </p>
              </li>
              <li>
                <p>
                  You acknowledge and agree that any suspension or termination of your access to the Platform may be
                  carried out without prior notice and you agree that Avaana will not be liable to you or any third
                  party for any such suspension or termination.
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        <h3>General</h3>
        <ol>
          <li>
            <p>
              Choice of law The laws governing these Terms will be the laws in the State of Victoria, Australia and you
              irrevocably submit to the exclusive jurisdiction of the courts of that State.
            </p>
          </li>
          <li>
            <p>Obligations of confidentiality</p>
            <ol>
              <li>
                <p>
                  Each party agrees to ensure that the Confidential Information of the other party ( Disclosing Party)
                  is kept confidential.
                </p>
              </li>
              <li>
                <p>A party who receives the Disclosing Party’s Confidential Information (Receiving Party) must not:</p>
                <ol>
                  <li>
                    <p>
                      directly or indirectly divulge or communicate or otherwise disclose the Confidential Information
                      of the Disclosing Party, in whole or part, to any third party; or
                    </p>
                  </li>
                  <li>
                    <p>
                      use any of the Confidential Information of the Disclosing Party for any purpose other than
                      exercising its rights or fulfilling its obligations under these terms and conditions,
                    </p>
                  </li>
                  <li>
                    <p>without the express prior written consent of the Disclosing Party.</p>
                  </li>
                </ol>
              </li>
              <li>
                <p>A Receiving Party must:</p>
                <ol>
                  <li>
                    <p>
                      take all precautions that are reasonably necessary to prevent any unauthorised disclosure of the
                      Disclosing Party’s Confidential Information to third parties or unauthorised use of such
                      Confidential Information; and
                    </p>
                  </li>
                  <li>
                    <p>
                      inform the Disclosing Party of any suspected or actual unauthorised disclosure or use of such
                      Confidential Information.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  A Receiving Party will not be in breach of its obligations with respect to disclosure of the
                  Disclosing Party’s
                </p>
                <p>Confidential Information if it discloses information that:</p>
                <ol>
                  <li>
                    <p>
                      relates to the existence of and the general nature of these terms and conditions to the Receiving
                      Party’s shareholders or as an announcement on any stock exchange upon which the Receiving Party is
                      listed;
                    </p>
                  </li>
                  <li>
                    <p>
                      is, or subsequently enters, the public domain, other than through a breach by it of its
                      obligations under this clause 11.2;
                    </p>
                  </li>
                  <li>
                    <p>
                      is required to disclose by statute, court order or a person acting under the authority of statute
                      or such order;
                    </p>
                  </li>
                  <li>
                    <p>
                      was developed independently by it, without the use of any of the Disclosing Party’s Confidential
                      Information; or
                    </p>
                  </li>
                  <li>
                    <p>
                      was provided to it by a third party who was not subject to any obligation or duty of
                      confidentiality at the time it was provided to the Receiving Party.
                    </p>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <p>Waiver</p>
            <p>
              Any waiver, in whole or part, of any rights available under these Terms is only valid if it is in writing
              and is limited to the instance referred to in the writing (or if no instance is referred to in the
              writing, to past breaches only).
            </p>
          </li>
          <li>
            <p>Severability</p>
            <p>
              If any provision of these Terms is held to be invalid, unenforceable or illegal for any reason, it is to
              be read down to give it as much effect as possible, or if it is not capable of having any effect at all,
              it is to be severed from these Terms, in which case, the remainder of these Terms will continue in full
              force.
            </p>
          </li>
          <li>
            <p>Entire agreement</p>
            <p>
              These Terms constitute the entire agreement between you and Avaana relating to the subject matter in these
              Terms and may not be modified except in writing, signed by both parties, or by a change to these Terms
              made by Avaana as set out in clause 10.2. These Terms supersede any past correspondence or discussions
              between you and Avaana.
            </p>
          </li>
          <li>
            <p>Avaana decisions</p>
            <p>Despite any other provision in these Terms:</p>
            <ol>
              <li>
                <p>
                  any consent, approval, requirement, decision or the like referred to in or, contemplated under these
                  Terms to be given, specified or made by Avaana, may be given or withheld, specified or made by Avaana,
                  at its absolute discretion unconditionally or subject to any conditions, from time to time as Avaana
                  in its absolute discretion thinks fit and may be revoked by Avaana, in its absolute discretion at any
                  time; and
                </p>
              </li>
              <li>
                <p>
                  any right which may be exercised by Avaana under these Terms or any other agreement relating to
                  Avaana, may be exercised from time to time as Avaana in its absolute discretion thinks fit, and Avaana
                  is not obliged to give its reasons for doing so, subject always to Avaana’s obligations under the law.
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        <h3>Definitions</h3>
        <p>In these Terms:</p>
        <ol>
          <li>
            <p>Account means a Provider Account or a Practitioner Account.</p>
          </li>
          <li>
            <p>API means Application Programming Interface.</p>
          </li>
          <li>
            <p>API Feeshas the meaning given in clause 4.7.</p>
          </li>
          <li>
            <p>API Information means any information provided to Avaana pursuant using the Integration Tools.</p>
          </li>
          <li>
            <p>
              Applicable Laws means any and all laws, statutes, regulations, by-laws, ordinances or subordinate
              legislation in force from time to time which pertains to a Provider or any Practitioner’s:
            </p>
            <ol>
              <li>
                <p>use of or access to the Platform and the Avaana Services;</p>
              </li>
              <li>
                <p>the uploading of any Provider Content on the Platform; and</p>
              </li>
              <li>
                <p>the provision of any Provider Services,</p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              and includes those laws, statutes, regulations, by-laws, ordinances or subordinate legislation relating to
              health services, equal opportunity, anti-discrimination, immigration, trade practices, fair trading,
              Intellectual Property Rights, Personal Information, privacy and confidentiality.
            </p>
          </li>
          <li>
            <p>
              Appointment means a booking for Provider Services through the Marketplace Service where at the time of
              making the Booking, the Client books a specific appointment time and date at which to receive the relevant
              Provider Services.
            </p>
          </li>
          <li>
            <p>Avaana, we, our and us means Avaana Pty Ltd ACN 610 520 600.</p>
          </li>
          <li>
            <p>Avaana Services includes:</p>
            <ol>
              <li>
                <p>the Marketplace Service;</p>
              </li>
              <li>
                <p>the Software Services;</p>
              </li>
              <li>
                <p>only in relation to Premium Providers, the Premium Services; and</p>
              </li>
              <li>
                <p>
                  other benefits and services a Provider may receive from Avaana through the Platform from time to time.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Booking includes:</p>
            <ol>
              <li>
                <p>an Appointment; and</p>
              </li>
              <li>
                <p>a Voucher.</p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              Calendar means the calendar functionality made available to the Provider and each of its Practitioners as
              part of the Software Services and which includes an ability to manage date and time availability for
              Appointments in accordance with clause 3.3.
            </p>
          </li>
          <li>
            <p>Cancellation Policy has the meaning given to that term in clause 3.6(a).</p>
          </li>
          <li>
            <p>
              Channels includes the Platform and any third party website, search engine, social media platform or other
              form of media through which the Provider Services are from time to time advertised for Booking.
            </p>
          </li>
          <li>
            <p>
              Checkout means that part of the Marketplace Service pursuant to which a Client is required to finalise its
              Booking for Provider Services and if applicable, pay for the Provider Services the subject of the Booking.
            </p>
          </li>
          <li>
            <p>
              Checkout Price means the price paid (or if the Client selects the Pay By Cash Option, payable) by a Client
              in consideration for the Provider Services the subject of a Booking which for the avoidance of doubt is
              equal to the Service Price less any Promo Code.
            </p>
          </li>
          <li>
            <p>
              Claim means any allegation, debt, cause of action, liability (whether actual, contingent or prospective),
              claim, demand, proceeding, suit, investigation or audit of any nature and whether present or future, fixed
              or unascertained, actual or contingent, arising at law, in equity, under statute or otherwise.
            </p>
          </li>
          <li>
            <p>
              Client means any person who books, purchases or receives Provider Services through use of the Avaana
              Services.
            </p>
          </li>
          <li>
            <p>Client Account means an account associated with a Client who uses or has used the Platform.</p>
          </li>
          <li>
            <p>
              Client Content means all information including reviews, account information, messages, audio, video,
              photos, text, images, compilations or other information uploaded to the Platform or otherwise provided to
              the Provider, Practitioners or Avaana by a Client including pursuant to a Client Review, upon Checkout or
              as a result of the creation of a Client Account.
            </p>
          </li>
          <li>
            <p>Commencement Date means the earlier of:</p>
            <ol>
              <li>
                <p>
                  if the Provider fully completes the Online Signup Form, the date on which the Provider ticks the box
                  to confirm their acceptance of these Terms;
                </p>
              </li>
              <li>
                <p>
                  if the Provider fully completes the Document Signup Form, the date on which the Provider signs the
                  Document Signup form or otherwise confirms their acceptance of these Terms (and regardless of whether
                  such confirmation is verbal or in writing);
                </p>
              </li>
              <li>
                <p>
                  if the Provider partially completes the Online Signup Form or the Document Signup Form, the date on
                  which the Provider confirms their acceptance of the Provider Content included in the Online Signup
                  Form or the Document Signup Form (as applicable) and confirms their acceptance of these Terms (whether
                  before or after the completion of the Online Signup Form or Document Signup Form and regardless of
                  whether such confirmation is verbal or in writing); and
                </p>
              </li>
              <li>
                <p>the Provider begins to receive the Avaana Services.</p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              Commission Rate means 30% or such other percentage agreed with the Provider, as being Avaana’s percentage
              share of the Service Price for the Provider Services the subject of a Booking.
            </p>
          </li>
          <li>
            <p>
              Community Guidelines means Avaana’s community guidelines in respect of Provider Content and Client Content
              accessible from the Platform.
            </p>
          </li>
          <li>
            <p>
              Confidential Information means the confidential information of a party which relates to the subject matter
              of these Terms and includes:
            </p>
            <ol>
              <li>
                <p>
                  in your case, information relating to you, your business and marketing plans, your customers and your
                  financial information you provide to Avaana and the API Information;
                </p>
              </li>
              <li>
                <p>
                  in our case, information relating to Avaana, our business and marketing plans, our customers, and our
                  financial information and the specifications of the Platform, Software Services and the Avaana
                  Services,
                </p>
              </li>
            </ol>
            <p>but excluding information which:</p>
            <ol>
              <li>
                <p>
                  is disclosed to you by a third party entitled to do so, whether before or after the date of these
                  Terms; or
                </p>
              </li>
              <li>
                <p>
                  was already lawfully in the your possession when it was given to you and was not otherwise acquired
                  from Avaana directly or indirectly; or
                </p>
              </li>
              <li>
                <p>
                  is generally available to the public at the date of these Terms or subsequently becomes so available
                  other than by reason of a breach of these Terms or any breach of confidentiality.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              Fees means the fees payable by a Provider to receive the Avaana Services and as amended from time to time
              in accordance with clause 4 of these Terms and includes the Marketplace Commission, Premium Subscription
              Fee and the Third Party Fees.
            </p>
          </li>
          <li>
            <p>
              Harmful Code means any computer virus, trojan, worm, other malicious computer code or other forms of
              interference that, directly or indirectly, is harmful or disabling or which assists in or enables
              unauthorised access to or corruption of data.
            </p>
          </li>
          <li>
            <p>Intellectual Property Rights means:</p>
            <ol>
              <li>
                <p>
                  patents, designs, trademarks and service marks (whether registered or unregistered) and any
                  applications for, or rights to apply for, registration of any patent, design, trade mark or service
                  mark
                </p>
              </li>
              <li>
                <p>
                  copyright (including copyright in software, websites, databases and advertising and other promotional
                  materials);
                </p>
              </li>
              <li>
                <p>
                  all rights to have information (including trade secrets, know-how, operating procedures and technical
                  information) kept confidential; and
                </p>
              </li>
              <li>
                <p>all other rights or protections having similar effect anywhere in the world.</p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              Integration Tools means any application, service, program, script, application programming interface, web
              service parameters or method which has been developed by Avaana, you or a third party for the purposes of
              integrating your time and date availability (including from a practice management system or an appointment
              calendar system used by your business) for the purposes of assisting Clients to make Appointments for your
              Provider Services in real time through the Marketplace Service.
            </p>
          </li>
          <li>
            <p>
              Loss means any damage, loss, liability, cost, charge, expense, penalty, outgoing or payment of any kind
              (including liability to a third party) including but not limited to any direct, indirect or consequential
              losses, loss of profit, loss of reputation and all interest, penalties and legal costs (calculated on a
              full indemnity basis) and advisor costs.
            </p>
          </li>
          <li>
            <p>
              Marketplace Commission means the Commission Rate multiplied by the Service Price of a Booking (and for the
              avoidance of doubt, not the Checkout Price paid by the Client).
            </p>
          </li>
          <li>
            <p>
              Marketplace Service means the online marketplace service that allows Clients to search, find, compare make
              Bookings with and which otherwise connects Clients with you and includes all services provided to you in
              connection with the Marketplace Service including the Provider Page, the appearance of the Provider’s
              business and Provider Content on the Platform and in search results, the Calendar and other benefits
              accessible to the Provider through the Platform.
            </p>
          </li>
          <li>
            <p>Minimum Fee means $10 per Booking.</p>
          </li>
          <li>
            <p>Our Invoice means an invoice issued by Avaana to you for Fees associated with the Avaana Services.</p>
          </li>
          <li>
            <p>
              Pay By Cash Option means the option selected by a Client using the Platform pursuant to which the Client
              chooses to pay for an Appointment by cash at the time of the Appointment.
            </p>
          </li>
          <li>
            <p>
              Payment Gateway Fees means all payment processing services fees or other amounts payable by Avaana or
              otherwise collected by Stripe in connection with the making of a Booking for Provider Services.
            </p>
          </li>
          <li>
            <p>Personal Information has the same meaning given to it as in the Privacy Act.</p>
          </li>
          <li>
            <p>Platform means:</p>
            <ol>
              <li>
                <p>
                  the website accessible from www.avaana.com.au and includes the Avaana Services which are accessible
                  from the website; and
                </p>
              </li>
              <li>
                <p>any applicable page or pages and contents of the Provider’s own website(s).</p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              post or upload means to make available Provider Content, information or materials to Avaana (including by
              email to Avaana’s representatives) or Clients in connection with the Platform or the Avaana Services
              including through the Signup Form, Business Dashboard, Avaana blog or otherwise through the use of the
              Avaana Services.
            </p>
          </li>
          <li>
            <p>
              Practitioner means any person employed by, contracted to or whom otherwise provides Provider Services for
              or on behalf of a Provider and the Provider’s business.
            </p>
          </li>
          <li>
            <p>
              Practitioner Account means an account on the Platform created by or on behalf of the Provider (including
              by Avaana) for a Practitioner, using the Signup Form or the Business Dashboard.
            </p>
          </li>
          <li>
            <p>
              Premium Provider means a provider that has paid the Premium Subscription Fee in consideration of receiving
              the Premium Services.
            </p>
          </li>
          <li>
            <p>
              Premium Services means those services which Avaana agrees to provide to Premium Providers in addition to
              those Avaana Services accessible by all Providers.
            </p>
          </li>
          <li>
            <p>
              Premium Subscription Fee means $39 per month payable in advance, payable by a Premium Provider in
              consideration for receiving the Premium Services.
            </p>
          </li>
          <li>
            <p>Privacy Act means the Privacy Act 1988 (Cth).</p>
          </li>
          <li>
            <p>
              Promo Code means any discount offered by Avaana and redeemable by a Client or potential Client in
              connection with Bookings for Provider Services including through the use of a promotional or discount code
              by a Client at Checkout.
            </p>
          </li>
          <li>
            <p>Provider or you means:</p>
            <ol>
              <li>
                <p>
                  an individual, firm or company which accesses the Platform and/or responds to a communication from
                  Avaana for the purposes of registering a Provider Account; and
                </p>
              </li>
              <li>
                <p>
                  an individual, firm or company which has registered a Provider Account for the purposes of receiving
                  the Avaana Services;
                </p>
              </li>
              <li>
                <p>
                  each of the Provider’s Practitioners, whether through the use of their respective Practitioner
                  Accounts or the Provider’s Provider Account; and
                </p>
              </li>
              <li>
                <p>
                  each of the employees, contractors and agents who may access and use the Platform or the Avaana
                  Services for or on behalf of the Provider using the Provider Account,
                </p>
              </li>
            </ol>
            <p>and your has a corresponding meaning.</p>
          </li>
          <li>
            <p>
              Provider Account means in relation to a Provider, an account on the Platform created by the Provider (or
              by Avaana on behalf of or in collaboration with the Provider), using the Signup Form.
            </p>
          </li>
          <li>
            <p>
              Provider Content means all information, documentation, content, images, video, audio, text, compilations
              or other information provided to Avaana on or before the Commencement Date or subsequently uploaded to the
              Platform through the Business Dashboard.
            </p>
          </li>
          <li>
            <p>
              Business Dashboard means the dashboard accessible to a Provider from the Platform pursuant to which the
              Provider can create, amend and modify details in connection with its Provider Account and upload Provider
              Content.
            </p>
          </li>
          <li>
            <p>
              Provider Fees means all amounts payable to a Provider by a Client in consideration for the provision by
              the Provider of a Provider Service to the Client.
            </p>
          </li>
          <li>
            <p>
              Provider Page means the internet page or pages and contents of the Provider’s designated section of the
              Platform.
            </p>
          </li>
          <li>
            <p>
              Provider Services means the health, fitness, wellbeing, spa, beauty and other goods and services which the
              Provider is in the business of providing and supplying and which are marketed and advertised for sale to
              Clients by the Provider through use of the Avaana Services;
            </p>
          </li>
          <li>
            <p>
              Service Price means in relation to a Provider Service, the price of the Provider Service which Clients can
              purchase using the Marketplace Service (as discounted by the Provider from time to time).
            </p>
          </li>
          <li>
            <p>
              Signup Form means the Document Signup Form or the Online Signup Form or a combination of both (as
              applicable).
            </p>
          </li>
          <li>
            <p>Site User means any person who has access to, or uses, the Platform.</p>
          </li>
          <li>
            <p>
              Software Services means the software specifically designed to be accessible to the Provider through its
              Provider Account including the Business Dashboard, the Provider Page and the Calendar.
            </p>
          </li>
          <li>
            <p>Standard Payment Terms means 7 days from the date of the Booking.</p>
          </li>
          <li>
            <p>Stripe means Stripe Payments Australia Pty Ltd A.C.N. 160 180 343.</p>
          </li>
          <li>
            <p>
              Stripe Connected Account Agreement means the agreement between Stripe and the Provider on the terms
              specified at https://stripe.com/au/connect-account/legal
            </p>
          </li>
          <li>
            <p>
              Stripe Terms of Service means the agreement between Stripe and the Provider on the terms specified at
              https://stripe.com/au/legal
            </p>
          </li>
          <li>
            <p>
              Terms means this agreement which sets out the terms and conditions upon which Avaana will provide the
              Avaana Services to the Provider and which comes into effect on the Commencement Date.
            </p>
          </li>
          <li>
            <p>
              Third Party Fees means the following fees that Avaana is required to pay to third parties in connection
              with the provision of the Avaana Services including:
            </p>
            <ol>
              <li>
                <p>the Payment Gateway Fees; and</p>
              </li>
              <li>
                <p>the API Fees,</p>
              </li>
            </ol>
            <p>and any reasonable margin applied by Avaana in respect of those fees from time to time.</p>
          </li>
          <li>
            <p>
              User Terms of Use and Booking Conditions means the terms of use and booking conditions which apply to all
              users of the Platform who view, have access to, and use the Platform and also apply to the Booking of
              products and/or services available for Booking through the Platform, available at
              https://avaana.com.au/terms-of-use.
            </p>
          </li>
          <li>
            <p>
              Visitor means a person who uses the Platform in accordance with all Applicable Laws who is not a Provider,
              Practitioner, a Client or a representative of Avaana.
            </p>
          </li>
          <li>
            <p>
              Voucher means a booking where a Client books a Provider Service with a specific Provider at a specific
              price but where, at the time of making the booking, the Client does not book a time and/or date for
              receiving that Provider Service but will be sent an electronic voucher in respect of the same.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h3>Interpretation</h3>
        <p>In these Terms, unless the context otherwise requires:</p>
        <ol>
          <li>
            <p>
              an obligation on a Provider or a Practitioner in these Terms becomes operative as from the Commencement
              Date;
            </p>
          </li>
          <li>
            <p>
              a reference to these Terms includes any hyperlinks (and any terms and conditions included through
              accessing such hyperlink), variations, amendments to or extensions of these Terms;
            </p>
          </li>
          <li>
            <p>
              any agreement, warranty, representation or obligation which binds or benefits two or more persons under
              these Terms, binds or benefits those persons jointly and severally;
            </p>
          </li>
          <li>
            <p>headings appear for convenience only and do not form part of these Terms;</p>
          </li>
          <li>
            <p>a reference to:</p>
            <ol>
              <li>
                <p>the singular includes the plural and vice versa;</p>
              </li>
              <li>
                <p>any gender includes all other genders;</p>
              </li>
              <li>
                <p>an entity includes an individual, a body corporate and a government;</p>
              </li>
              <li>
                <p>
                  any other agreement or instrument where amended or replaced means that agreement or instrument as
                  amended or replaced;
                </p>
              </li>
              <li>
                <p>“including” in these Terms means “including without limitation”;</p>
              </li>
              <li>
                <p>any thing or amount is a reference to the whole and/or each part of it;</p>
              </li>
              <li>
                <p>“$” or “dollars” is a reference to the lawful currency of Australia;</p>
              </li>
              <li>
                <p>a day means a period of time commencing at midnight and ending 24 hours later;</p>
              </li>
              <li>
                <p>
                  a week means a 7 day period commencing on Monday and concluding on the following Sunday (inclusive);
                </p>
              </li>
              <li>
                <p>a month means a calendar month;</p>
              </li>
            </ol>
          </li>
          <li>
            <p>a reference to a statute or statutory provision includes any statutory provision which:</p>
            <ol>
              <li>
                <p>amends, extends, consolidates or replaces; or</p>
              </li>
              <li>
                <p>
                  has been amended, extended, consolidated or replaced by, that statute or statutory provision and any
                  other orders, regulations, instruments or other subordinate legislation made under that statute or
                  statutory provision;
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>examples contained in these Terms are descriptive only and are not intended to be exhaustive; and</p>
          </li>
          <li>
            <p>
              where a period of time is specified and dates from a given day or the day of an act or event it must be
              calculated exclusive of that day.
            </p>
          </li>
        </ol>
      </li>
    </ol>
  </div>
</div>
